import React, { useEffect, useState } from 'react';
import axios from '../services/tmdb';
import requests from '../services/requests';
import './Banner.css';
import MovieModal from './MovieModal';

function Banner() {
  const [movie, setMovie] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    async function fetchData() {
      try {
        const request = await axios.get(requests.fetchNetflixOriginals);
        const randomMovie = request.data.results[
          Math.floor(Math.random() * request.data.results.length)
        ];
        setMovie(randomMovie);
      } catch (error) {
        console.error("Erro ao carregar banner:", error);
      }
    }
    fetchData();
  }, []);

  return (
    <>
      <header
        className="banner"
        style={{
          backgroundSize: "cover",
          backgroundImage: `url("https://image.tmdb.org/t/p/original/${movie?.backdrop_path}")`,
          backgroundPosition: "center center",
        }}
      >
        <div className="banner__contents">
          <h1 className="banner__title">
            {movie?.title || movie?.name || movie?.original_name}
          </h1>

          <div className="banner__buttons">
            <button className="banner__button" onClick={() => setShowModal(true)}>
              Assistir
            </button>
            <button className="banner__button" onClick={() => setShowModal(true)}>
              Minha Lista
            </button>
          </div>

          <h1 className="banner__description">
            {movie?.overview ? movie.overview.substring(0, 150) + "..." : ""}
          </h1>
        </div>
        <div className="banner--fadeBottom" />
      </header>

      {/* RENDERIZAÇÃO DO MODAL - Crucial estar aqui */}
      {showModal && movie && (
        <MovieModal 
          movie={movie} 
          onClose={() => setShowModal(false)} 
        />
      )}
    </>
  );
}

export default Banner;
